<script setup lang="ts">
import { hasValue, isEmpty } from '@hprofits/utils/fp/optional';
import { watchEffect } from 'vue';

import { useCampaignRoute } from '@/modules/campaigns/composables/useCampaignGroupRoute';
import { useNotFoundRedirect } from '@/modules/campaigns/composables/useNotFoundRedirect';

import CampaignGroupLayout from './CampaignGroupLayout.vue';

defineOptions({ name: 'CampaignLayout' });

const { campaignGroupId } = useCampaignRoute();
const redirect404 = useNotFoundRedirect();

watchEffect(() => {
  if (isEmpty(campaignGroupId.value)) {
    redirect404();
  }
});
</script>

<template>
  <CampaignGroupLayout v-if="hasValue(campaignGroupId)" :campaign-group-id="campaignGroupId">
    <slot />
  </CampaignGroupLayout>
</template>
